<template>
  <button
    class=" tw-flex tw-justify-center tw-align-middle  tw-transition-all tw-px-6  tw-cursor-pointer tw-rounded-xl tw-text-buttons tw-font-semibold
  tw-m-0 tw-box-border tw-outline-none"
    :class="{
      'tw-bg-white tw-border tw-border-solid tw-border-primary-600 tw-text-black-400 hover:tw-bg-primary-200 active:tw-bg-primary-400':
        outlined && !disabled,
      'tw-bg-primary tw-border-0 hover:tw-bg-black-400 hover:tw-text-primary active:tw-bg-black active:tw-text-primary':
        !secondary && !disabled && !outlined,
      'tw-bg-mint tw-border-0 hover:tw-bg-black-400 hover:tw-text-mint active:tw-bg-black active:tw-text-mint':
        secondary && !outlined && !disabled,
      'tw-text-black': !disabled,
      '!tw-p-2  tw-w-32 tw-h-10': small,
      'tw-py-3 tw-w-50 tw-h-11 tw-min-w-max': !small,
      'tw-bg-primary-100 tw-border-solid tw-border-primary-600 tw-pointer-events-none tw-text-primary-600 tw-border':
        disabled && outlined,
      'tw-pointer-events-none tw-border-0 tw-bg-black-50 tw-text-black-100':
        disabled && !outlined,
      'tw-w-full': full,
      'tw-pointer-events-none': loading && !disabled
    }"
    @click="$emit('click')"
  >
    <div
      class=" tw-flex tw-items-center"
      :class="{
        ' tw-text-white tw-text-opacity-0 tw-h-6 tw-w-6 tw-border-2 tw-border-solid tw-border-black tw-rounded-full tw-block tw-border-b-transparent tw-animate-spin':
          loading && !disabled
      }"
    >
      <lgk-icon
        v-if="iconLeft !== ''"
        :icon="iconLeft"
        class="tw-h-6 tw-w-6 tw-fill-current tw-mr-1"
      />
      {{ text }}
      <lgk-icon
        v-if="iconRight !== ''"
        :icon="iconRight"
        class="tw-h-6 tw-w-6 tw-fill-current tw-ml-1"
      />
    </div>
  </button>
</template>

<script>
import LgkIcon from './LgkIcon.vue'
export default {
  name: 'LgkButton',
  components: { LgkIcon },
  props: {
    small: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Default'
    },
    full: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    iconRight: {
      type: String,
      default: ''
    },
    iconLeft: {
      type: String,
      default: ''
    }
  }
}
</script>
